import React, { useContext } from 'react';
import { DestinationContext } from '../../../contexts/DestinationContext';
import styles from './TopReasons.module.scss';

const TopReasons = () => {
  const destination = useContext(DestinationContext);
  const reasons = destination?.destinationDescription?.reasons;

  if (!Array.isArray(reasons) || reasons.length === 0) return null;

  return (
    <section className={styles.section}>
      <div className={styles.wrap}>
        <div className={styles.header}>
          <div className={styles.eyebrow}>Why Come Here</div>
          <h2 className={styles.heading}>
            Top {reasons.length} Reasons to Visit <em>{destination?.name}</em>
          </h2>
        </div>
        <div className={styles.reasons}>
          {reasons.map((reason, i) => (
            <div className={styles.reason} key={reason.title || i}>
              <div className={styles.num}>{i + 1}</div>
              {reason.title && <h4>{reason.title}</h4>}
              <p>{reason.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TopReasons;
